import franchiseList from './franchiseList/franchiseListSlice';
import groupLogos from './groupLogos/groupLogosSlice';
import customLogos from './customLogos/customLogosSlice';

const root = {
	franchiseList,
	groupLogos,
	customLogos
};

export default root;
